import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Accelerate your time to value`,
  description: `with Segment advisory, jumpstart, and resident architect programs.`,
}

const button = {
  text: `Get a demo`,
  url: `/demo/`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Contents>
            <StyledButton
              aria-label="Demo Button"
              size="large"
              color="primary"
              variant="filled"
              tag="a"
              href={getAbsoluteUrl(button.url, pageConfig)}
            >
              {button.text}
            </StyledButton>
          </HeroRecipe.Contents>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
  ${HeroRecipe.Contents}, ${HeroRecipe.Copy} {
    align-self: start;
  }
`
const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    padding-bottom: 20px;
  }
`

const StyledButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    margin-top: 20px;
  }
`

export default Hero
